module.exports = __webpack_public_path__ + "static/media/weatherData.9fbacdd6.png";